import { Link } from 'react-router'
import { Eye, PauseCircle } from 'lucide-react'
import { useDashboardScope } from './DashboardScope'

/**
 * On a suspended organization's dashboard pages: why nothing can be changed.
 * (Staff viewing as the tenant see `ViewAsBanner` from the layout instead.)
 */
export function ReadOnlyBanner() {
  const scope = useDashboardScope()
  if (scope.readOnlyReason !== 'suspended') return null
  return (
    <div
      role="status"
      className="mb-6 flex items-start gap-2 rounded-lg border border-warning-border bg-warning-subtle px-3 py-2 text-body text-warning"
    >
      <PauseCircle className="mt-0.5 size-4 shrink-0" />
      <span>
        <strong className="font-semibold">{scope.tenantName} is suspended.</strong> The dashboard is read-only and API
        keys are disabled. Envelopes already sent can still be signed. Contact PixelSign support to reactivate.
      </span>
    </div>
  )
}

interface ViewAsBannerProps {
  /** Where Exit goes (the tenant's ops page). */
  exitTo: string
}

/** Staff viewing a tenant's dashboard: whose it is, that it's recorded, and the way out. */
export function ViewAsBanner({ exitTo }: ViewAsBannerProps) {
  const scope = useDashboardScope()
  return (
    <div
      role="status"
      className="mb-6 flex flex-wrap items-center gap-2 rounded-lg border border-info-border bg-info-subtle px-3 py-2 text-body text-info"
    >
      <Eye className="size-4 shrink-0" />
      <span className="min-w-0 flex-1">
        Viewing <strong className="font-semibold">{scope.tenantName}</strong> as PixelSign staff. Read-only; this visit
        is recorded in the organization&apos;s activity.
      </span>
      <Link to={exitTo} className="font-medium underline underline-offset-4">
        Exit
      </Link>
    </div>
  )
}
